// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import { getDatabase } from 'firebase/database';
import { child, get, getDatabase, ref, set } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyBOdjGecuobqVbT28YWOd6swhumtpGU6Ew",
  authDomain: "asva-beach-tv.firebaseapp.com",
  projectId: "asva-beach-tv",
  storageBucket: "asva-beach-tv.firebasestorage.app",
  messagingSenderId: "307857301312",
  appId: "1:307857301312:web:60f0a473b3c6c42299e4a5",
  measurementId: "G-89JV9SHY06",
  databaseURL: "https://asva-beach-tv-default-rtdb.firebaseio.com/",
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getDatabase(app);
/** Shown in admin UI so you can confirm the app points at the same RTDB as the Firebase Console. */
export const firebaseDatabaseUrl = (firebaseConfig.databaseURL || "").replace(/\/$/, "");

onAuthStateChanged(auth, (user) => {
    if (user) {
      // once we know we have a user, write their profile
      // to the database if it doesn't exist
    const dbRef = ref(db);
    get(child(dbRef, `profiles/${user.uid}`))
              .then(snapshot => {
                if (!snapshot.exists()) {
                  // User profile doesn't exist, create it
                  set(ref(db, 'profiles/' + user.uid), {
                    fullName: user.displayName,
                    email: user.email,
                    signupDate: Date.now(),
                    membershipExpires: Date.now() + 1000 * 60 * 60 * 24 * 30 * 6 // 6 months
                  });
                }
              })   
      .catch(err => console.error("DB write failed:", err));
    }
  });